import Vue from 'vue';
import Main from './main.vue';

const LoadingConstructor = Vue.extend(Main);

function Loading(opts = {}) {
  if (typeof opts === 'string') {
    opts = {
      content: opts,
    };
  }
  const instance = new LoadingConstructor({
    data: {
      loadingStatus: true,
      fullScreenStatus: true,
      ...opts,
    },
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  return instance;
}

export default Loading;
